
import { defineComponent, computed, Ref, inject } from "vue";
import { store } from "@/store";
import CloseSVG from "@/components/CloseSVG.vue";
import { ClientDimensions, SheetLabel } from "@/types";
import { ActionTypes } from "@/store/actions";

export default defineComponent({
  name: "Mismatched",
  components: {
    CloseSVG,
  },
  setup() {
    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    const clientDimensions = computed<ClientDimensions>(() => store.getters.clientDimensions);
    const currentLabel = computed<SheetLabel>(() => store.getters.currentLabel);
    const orderHistoryLink = computed<string>(() => `${window.location.origin}/customer/orders/`);

    const returnToTroubleShooting = () => {
      store.dispatch(ActionTypes.SET_MODAL, "troubleShooting");
    };

    const openSizesModal = () => {
      store.dispatch(ActionTypes.SET_MODAL, "labelSizes");
    };

    const openContact = () => {
      store.dispatch(ActionTypes.SET_MODAL, "contact");
    };

    return {
      closeModal,
      bounceTransition,
      fadeTransition,
      clientDimensions,
      currentLabel,
      orderHistoryLink,
      returnToTroubleShooting,
      openSizesModal,
      openContact,
    };
  },
});
